export const config = {
  routes: {
    home: "/",
    page: "/de/:pageUri",
  },
} as const
